module.exports = __webpack_public_path__ + "img/LaBase-BurgerMoorea-600px.208f411a.jpg";